import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Cubes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      random: Math.floor(Math.random() * 12) + 1,
      answer: "",
      question: 1,
      result: 0,
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerOperation = (event) => {
    event.preventDefault();
    var good = this.state.random * this.state.random * this.state.random;
    if (Number(this.state.answer) === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.random +
          String.fromCharCode(179) +
          " = " +
          good,
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.random +
          String.fromCharCode(179) +
          " = " +
          good,
      });
    }
    var rand = Math.floor(Math.random() * 12) + 1;
    var que = Math.floor(Math.random() * 2) + 1;
    var res = rand * rand * rand;
    this.setState({ random: rand, question: que, result: res, answer: "" });
  };

  mySubmitHandlerResultat = (event) => {
    event.preventDefault();
    var good = this.state.random;
    if (Number(this.state.answer) === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.result +
          " = " +
          good +
          String.fromCharCode(179),
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.result +
          " = " +
          good +
          String.fromCharCode(179),
      });
    }
    var rand = Math.floor(Math.random() * 12) + 1;
    var que = Math.floor(Math.random() * 2) + 1;
    var res = rand * rand * rand;
    this.setState({ random: rand, question: que, result: res, answer: "" });
  };

  myChangeHandler = (event) => {
    this.setState({ answer: event.target.value });
  };

  render() {
    // Si question == 1 alors le cube sera posé
    if (this.state.question === 1) {
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Cubes</h2>
            </div>
          </div>

          <div className="container">
            <p>Les questions peuvent être posées dans les 2 sens.</p>
            <p className={this.state.messageColor}>{this.state.message}</p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerOperation}
            >
              <div className="row">
                <label className="label-exos">{this.state.random}</label>
                <label style={{ fontSize: 20 }}>
                  {String.fromCharCode(179)}
                </label>
                <label style={{ marginLeft: 5 }} className="label-exos">
                  {" "}
                  = ?{" "}
                </label>
              </div>
              <input
                className="input-square"
                type="number"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
            <p>Besoin d'un peu d'aide ? Scroll la page pour voir le cours ;)</p>

          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>

          <div class="rappel">
            <h3>Rappel de cours :</h3>
            <div>
              {Array.from({ length: 12 }, (_, i) => (
                <p key={i}> {i + 1}³ = {(i + 1) ** 3} </p>
              ))}
            </div>
          </div>

        </div>
      );
    } else {
      // Sinon le resultat sera posé
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Cubes</h2>
            </div>
          </div>

          <div className="container">
            <p>Les questions peuvent être posées dans les 2 sens.</p>
            <p className={this.state.messageColor}>{this.state.message}</p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerResultat}
            >
              <div className="row">
                <label className="label-exos">{this.state.result} = ?</label>
                <label style={{ fontSize: 20 }}>
                  {String.fromCharCode(179)}
                </label>
              </div>
              <input
                className="input-square"
                type="number"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
            <p>Besoin d'un peu d'aide ? Scroll la page pour voir le cours ;)</p>

          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>

          <div class="rappel">
            <h3>Rappel de cours :</h3>
            <div>
              {Array.from({ length: 12 }, (_, i) => (
                <p key={i}> {i + 1}³ = {(i + 1) ** 3} </p>
              ))}
            </div>
          </div>

        </div>
      );
    }
  }
}

export default Cubes;
